export function getBaseTierByBrand (brand) {
  if (brand === 'bassica') return 'b0'
  return 't0'
}

export function groupTiers (tiers) {
  if (!tiers || !tiers.length) return []

  const order = []
  const map = new Map()

  tiers.forEach((tier, index) => {
    if (!map.has(tier)) {
      map.set(tier, { tier, quantity: 0, indices: [], isLast: false })
      order.push(tier)
    }

    const group = map.get(tier)
    group.quantity++
    group.indices.push(index)
    if (index === tiers.length - 1) group.isLast = true
  })

  return order.map(tier => map.get(tier))
}



// WEBPACK FOOTER //
// ./src/helpers/tier.js